import ReactOnRails from 'react-on-rails'

import Login from 'startup/LoginWrapper'

ReactOnRails.register({ Login })
